export default __webpack_public_path__ + "static/media/_dots_medium_icon.5a7e2ace.svg";